module.exports = __webpack_public_path__ + "static/media/tändsticksask-min.9044a40e.png";